import { Skeleton as MuiSkeleton, Stack } from '@mui/material';
import { memo } from 'react';

export const OnboardingMyPlanSkeleton = memo(() => (
  <Stack sx={{ alignItems: 'center', minHeight: '100vh', bgcolor: 'white', pt: 12 }}>
    <MuiSkeleton variant="rounded" sx={{ width: 186, height: 2, borderRadius: '2px' }} />

    <Stack sx={{ alignItems: 'center', gap: 4, mt: 14, px: 5 }}>
      <MuiSkeleton variant="rounded" sx={{ width: 300, height: 60, borderRadius: '8px' }} />
      <MuiSkeleton variant="rounded" sx={{ width: 340, height: 40, borderRadius: '8px' }} />
    </Stack>

    <MuiSkeleton variant="rounded" sx={{ width: 440, height: 360, borderRadius: '40px', mt: 8 }} />

    <MuiSkeleton variant="rounded" sx={{ width: 300, height: 52, borderRadius: '64px', mt: 13 }} />
  </Stack>
));
